import { Container } from 'inversify';

export const deviceManagementContainer = new Container({ defaultScope: 'Singleton' });
